import React from "react";
//import "./App.css";
import "./style.css";
import AppNav from "../Nav";

function Header() {
  /*  const [value, setValue] = React.(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  }; */
  return <AppNav></AppNav>;
}

export default Header;
